import React from 'react';
import CsvDownloadButton from 'react-json-to-csv';
import { CheckIcon, DeleteIcon, DownloadIcon } from '../../../Constants';
import ActionTooltip from '../ActionTooltip';
import GenerateCapFile from './GenerateCapFile';

const actionClassName = 'inline-flex min-h-11 items-center gap-2 rounded-md px-2 py-2 text-left text-sm font-medium text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 disabled:cursor-not-allowed disabled:opacity-50 dark:text-zinc-300 dark:hover:bg-zinc-800 dark:hover:text-zinc-100';

function Action({ label, description, icon: Icon = DownloadIcon, onClick }) {
  return (
    <ActionTooltip description={description}>
      <button type="button" className={actionClassName} onClick={onClick}>
        <i className="sm shrink-0" aria-hidden="true"><Icon /></i>
        {label}
      </button>
    </ActionTooltip>
  );
}

export default function RegistrationActions({ role, eventId, allowWaivers, allowGuestWaivers,
  allSubmissions, downloadAllWaivers, downloadAllGuestWaivers, downloadSubmissions,
  clearLeadData, deleteAllRegistrations }) {
  if (Number(role) === 7) return null;
  const confirm = (message, action) => () => { if (window.confirm(message)) action(); };
  return (
    <div role="group" aria-label="Registration actions" className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-zinc-200 pt-4 dark:border-zinc-800">
      {role <= 2 && allowWaivers && (
        <Action label="All Waivers" description="Download signed waivers for all registrations in this event. This may take a few minutes."
          onClick={confirm('Are you sure you want to download all waivers, this may take a few minutes?', downloadAllWaivers)} />
      )}
      {role <= 2 && allowGuestWaivers && (
        <Action label="All Guest Waivers" description="Download signed guest waivers for all registrations in this event. This may take a few minutes."
          onClick={confirm('Are you sure you want to download all guest waivers, this may take a few minutes?', downloadAllGuestWaivers)} />
      )}
      {allSubmissions.length === 0 ? (
        <>
          <Action label="All Data" description="Prepare a CSV of all registrations in this event, regardless of the table filters. Then select Download CSV."
            onClick={confirm('Are you sure you want to download all data, this may take a few minutes?', () => downloadSubmissions(false))} />
          <Action label="Filtered Data" description="Prepare a CSV of registrations matching the current table filters, across all pages. Then select Download CSV."
            onClick={confirm('Are you sure you want to download all data, this may take a few minutes?', () => downloadSubmissions(true))} />
        </>
      ) : (
        <ActionTooltip description="Download the CSV prepared by All Data or Filtered Data.">
          <CsvDownloadButton target="_blank" delimiter="," data={allSubmissions} className={actionClassName}>Download CSV</CsvDownloadButton>
        </ActionTooltip>
      )}
      <GenerateCapFile key={eventId} role={role} eventId={eventId} buttonClassName={actionClassName} />
      {role === 1 && (
        <>
          <Action label="Resend Lead Data" icon={CheckIcon} description="Clear sent indicators for this event so the nightly job can resend eligible lead data. Confirmation is required."
            onClick={confirm('Are you sure to resend lead data?', clearLeadData)} />
          <Action label="All Registrations" icon={DeleteIcon} description="Delete all registrations in this event. This action is destructive and requires confirmation."
            onClick={confirm('Are you sure to delete ALL registrations?', deleteAllRegistrations)} />
        </>
      )}
    </div>
  );
}
